import { render, staticRenderFns } from "./ButtonDownload.vue?vue&type=template&id=236a0846&scoped=true&lang=pug&"
import script from "./ButtonDownload.vue?vue&type=script&lang=ts&"
export * from "./ButtonDownload.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonDownload.vue?vue&type=style&index=0&id=236a0846&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236a0846",
  null
  
)

export default component.exports